import * as React from "react"
import styled from "styled-components"
import { Link } from "gatsby"
import { offBlack } from "../../constants/colors"

const getButtonCss = (disabled: boolean) => `
  color: ${offBlack};
  padding: 0 3px 3px;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-size: 0.9em;

  &:hover {
    text-decoration: none;
    color: ${offBlack};
    border-bottom: 2px solid hsla(0, 0%, 0%, 0.7);
  }
  
  ${
    disabled
      ? `
    cursor: pointer;
    text-decoration: none;
    pointer-events: none;
  `
      : ""
  }
`

const Button = styled.button<{ disabled: boolean }>`
  ${({ disabled }) => getButtonCss(disabled)}
`

const StyledLink = styled(Link)<{ disabled: boolean }>`
  ${({ disabled }) => getButtonCss(disabled)}
`

interface UnderlineButtonProps {
  onClick?: () => void
  to?: string
  children: React.ReactNode
  className?: string
  disabled?: boolean
}

const UnderlineButton = ({
  onClick,
  to,
  children,
  className,
  disabled,
}: UnderlineButtonProps): JSX.Element =>
  onClick ? (
    <Button disabled={disabled} className={className}>
      {children}
    </Button>
  ) : (
    <StyledLink disabled={disabled} to={to} className={className}>
      {children}
    </StyledLink>
  )

export default UnderlineButton
